<template lang="pug">
section.wam-content.onboarding-mt(
    v-if="hasUserAccessToManageTaxo"
    :class="[{'full-width': isDataLoading || emptyCustomTaxonomies}, {'is-open': selectedSegmentId}]")

    template(v-if="isProcessing")
        ScreenLockLoader

    //- Loading data
    template(v-if="isDataLoading")
        spinner.l-flex-row--center.l-align-center(width="200" height="200")

    template(v-else)

        //- Modal
        div.overlay-close(
            v-if="displayModal || displayTaxonomyModal || displaySharingTaxonomyModal"
            @click="closeForm()"
        )
        div.modal.modal-h-full.modal__medium.modal-segment(v-if="displayModal")
            SegmentForm(:segment="segmentInfo")

        template(v-if="displayConfirmationModal")
            .overlay-close(@click="closeModal()")
            .modal.modal-h-auto.modal__large.modal-delete
                ConfirmationModal(modalClassName="modal-wrapper")
                    template(slot="content")
                        div It looks like you have not saved your changes to this taxonomy.
                        div Leaving this taxonomy will discard changes!
                    template(slot='footer')
                        .footer-content.l-flex-row--between
                            .btn.btn--medium.btn--round(@click='closeModal()') Close
                            .btn.btn--medium.btn--round.btn-delete(@click.once='discardChanges()') Discard
                            .btn.btn--medium.btn--round(@click.once='saveChanges()') Save

        div.modal.modal__medium.modal-taxonomy(v-if="displayTaxonomyModal" :class="modalTaxonomyClass")
            TaxonomyForm(:dataPayload="editTaxonomyPayload")
        div.modal.modal__medium.modal-taxonomy.taxonomy-sharing(v-else-if="displaySharingTaxonomyModal")
            TaxonomySharingForm


        //- Zero state
        template(v-if="emptyCustomTaxonomies")
            section.l-flex-column.is-empty.zero-state
                p.zero-state-message There are no taxonomy on your account.
                button.btn.btn--round.btn-rev.btn--big(@click="setTaxonomyForm({ displayModal: true, type: 'create' })") Create a taxonomy

        template(v-else)
            //- DATA TYPE
            Panel(panelClassName="mt-hierarchy")
                template(slot="header")
                    div.l-flex-row--between
                        div.l-flex-row
                            sectionHeader(title="Taxonomies")
                            div.section-header--counter {{customTaxonomies.length + ' / ' + maximumTaxos}}
                        <el-dropdown trigger="click" placement="bottom-start" @command="handleCommand">
                            <button class="btn-border btn--small btn--round l-flex-row l-align-center">
                                | Actions
                                <svg-icon class="sub-navigation-cta-icon is-white" name="dots" size="small" style="margin-right: -5px;" />
                            </button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="download" class="l-flex-row dropdown-menu-action">
                                    <svg-icon name="arrow-direction_right" size="tiny" />
                                    <span>Download taxonomy</span>
                                </el-dropdown-item>
                                <el-dropdown-item command="import" class="l-flex-row dropdown-menu-action">
                                    <svg-icon name="arrow-direction_right" size="tiny" />
                                    <span>Import taxonomy</span>
                                    <input style="visibility: hidden; opacity: 0" class="inputfile" id="nav-uploadTaxo" ref="nav-uploadTaxo" type="file" accept=".csv" @click="displayWarning" @change="_importTaxonomy($event)" />
                                </el-dropdown-item>
                                <el-dropdown-item command="new" class="l-flex-row dropdown-menu-action">
                                    <svg-icon name="arrow-direction_right" size="tiny" />
                                    <span>Create new taxonomy</span>
                                </el-dropdown-item>
                                <el-dropdown-item command="share"  class="l-flex-row dropdown-menu-action">
                                    <svg-icon name="arrow-direction_right" size="tiny" />
                                    <span>Share taxonomy</span>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                //- SEARCH
                template(slot="content")
                    div.section-header--action-item.action-item-direct.search-criteria-wrapper
                        input.search-criteria.taxo(
                            @input="checkInput($event)"
                            :class="{'isFocus':searchValue!==''}"
                            placeholder="Search segment"
                            v-model.trim="searchValue"
                            @keyup.esc="resetSearch(true)"
                            @keyup.enter="launchSearch()")
                        svg-icon.search-reset.taxo(name='close' size='small' @click.native="resetSearch(true)" v-if="searchValue !== ''")
                        div.search-filter
                            | Filter on :
                            select.search-targets.taxo(v-model="searchTarget")
                                option(v-for="item in searchTargets", :key="item.value" :value="item.value") {{ item.label }}

                template(slot="content")
                    template(v-if="!isSearching || isRedirectedFromAllocation")
                        ul.list_taxonomy.scrollbar.is-scrollable
                            li.list-item_taxonomy(v-for="(taxo, index) in customTaxonomies")
                                div.item_taxonomy.area-item.l-flex-row--between(
                                    @click="selectTaxonomy(taxo.id, taxo.taxonomy_type)"
                                    :class="{ 'is-selected': selectedTaxoId === taxo.id }")
                                    div.area-item-info
                                        div.area-item-id.area-item-info-small {{ taxo.id }}
                                        div.area-item-label(:title="taxo.label") {{ taxo.label }}
                                        div.l-flex-row
                                            svg-icon(name="calendar" size="small" title="Recency")
                                            div.area-item-info-small {{ taxo.retention + ' days' }}
                                    div.l-flex-row.l-align-center
                                        div.item_action(@click.stop="editTaxonomy(taxo)")
                                            svg-icon(name='edit' size="medium" title="edit")
                                        div.item_action(@click.stop="setEditSharing(taxo)")
                                            div.l-flex-row(:title="getSharingCounter(taxo) + ' shared'")
                                                svg-icon(name='share' size="medium" )
                                                div {{getSharingCounter(taxo)}}

                    //- RESULT LIST
                    template(v-else)
                        div.search-result-wrapper.scrollbar.is-scrollable
                            div.no-results(v-if="!showResultList") No results found
                            div.category(v-else)
                                div.category-label {{ searchResultsHeader }}

                                div.tree-view
                                    div.tree-item(v-for="(customSegment, index) in searchResultsData" :key="customSegment.id")
                                        div.tree-node.tree-node__tp(@click="selectCustomSegment(customSegment.id)")
                                            div.node-icon
                                                div.node-icon__default
                                            div.tree-node__info
                                                div.l-flex-row.tree-node__top-info
                                                    div.tree-node__id {{ customSegment.id }}
                                                div.tree-node__label {{ customSegment.label }}


            //- MANAGE TAXO TREE
            section.manage-taxonomy-wrapper(:class="[{'is-loading': isLoading}, {'is-empty': !isLoading && !showHierarchy}]")

                //- Loading data
                template(v-if="isLoading")
                    spinner.l-flex-row--center.l-align-center(width="100" height="100")

                template(v-else)
                    template(v-if="showHierarchy")
                        div.l-flex-row--between
                            div.l-flex-row
                                h1.section-header--title.flex-1 Hierarchy
                                div.info-counter.l-flex-row
                                    div.section-header--counter(:class="taxoCounterClassName") {{taxoCounters + ' / ' + maximumSegment}}
                            div.counter-wrapper.l-flex-row
                                div.info-counter.l-flex-row
                                    div.counter-label.counter-dragged(:class="{'is-active': counters.dragged > 0}") Dragged
                                div.info-counter.l-flex-row
                                    div.counter-label.counter-created Created - {{ counters.created }}
                                div.info-counter.l-flex-row
                                    div.counter-label.counter-updated Updated - {{ counters.updated }}
                                div.info-counter.l-flex-row
                                    div.counter-label.counter-deleted Deleted - {{ counters.deleted }}

                        div.manage-taxonomy-actions.l-flex-row--between
                            div.l-flex-row
                                button.btn-simple.medium(@click="createCustomSegment()")
                                    svg-icon(name='add' size='small' )
                                    span Create segment
                                button.btn-simple.medium(
                                    title="Download taxonomy"
                                    @click="_exportTaxonomy()"
                                )
                                    svg-icon(name='download' size='small' )
                                    span Download
                                button.btn-simple.medium(title="Import taxonomy")
                                    svg-icon(name='upload' size='small' )
                                    label(for="uploadTaxo" class="mt-inputfile-label") Import
                                        input(
                                            class="inputfile" id="uploadTaxo" ref="uploadTaxo" type="file" accept=".csv"
                                            @click="displayWarning()" @change="_importTaxonomy($event)"
                                        )

                            div.l-flex-row
                                button.btn-simple.medium(
                                    :class="{'ui-disabled': !hasCounterActivated}"
                                    @click="cancelChanges()"
                                ) Cancel
                                button.btn-simple.medium(
                                    :class="{'ui-disabled': !hasCounterActivated}"
                                    @click="saveHierarchy()"
                                ) Save

                        section.manage-taxonomy-information.l-flex-row(
                            ref="manageTaxonomyColumnsContainer"
                            :class="{'is-open': selectedSegmentId}"
                        )
                            ManageTaxonomyTree(:treeData="treeData" :scrollId="'0'")

                    template(v-else)
                        sectionHeader(title="Hierarchy")
                        section.no-hierarchy
                            div.zero-state
                                p.zero-state-message
                                    | There are no segments
                                    br
                                    | in this hierarchy
                                div.l-flex-row--between
                                    div.btn.btn--round.btn-rev.btn--big( @click="createCustomSegment()") Create a segment
                                    div.btn.btn--round.btn-rev.btn--big
                                        label(for="uploadTaxo" class="mt-inputfile-label") Import hierarchy
                                            input(
                                                class="inputfile"
                                                id="uploadTaxo"
                                                ref="uploadTaxo"
                                                type="file"
                                                accept=".csv"
                                                @click="displayWarning()"
                                                @change="_importTaxonomy($event)")

            //- CUSTOM SEGMENT DETAIL
            SegmentDetails(
                v-if="selectedSegmentId"
                :class="{'is-open': selectedSegmentId}"
                :segment="segmentInfo")

</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import { cloneDeep, get, head, includes, isEmpty, isNil, map } from 'lodash'

import helpers from '@/store/ui/manageTaxonomy/helpers'

import ConfirmationModal from '@/components/common/confirmationModal'
import ManageTaxonomyTree from '@/components/onBoarding/ManageTaxonomyTree'
import Panel from '@/components/common/Panel'
import SectionHeader from '@/components/common/SectionHeader'
import SegmentDetails from '@/components/onBoarding/segmentDetails'
import SegmentForm from '@/components/onBoarding/segmentForm'
import ScreenLockLoader from '@/components/common/ScreenLockLoader'
import TaxonomyForm from '@/components/onBoarding/TaxonomyForm'
import TaxonomySharingForm from '@/components/onBoarding/TaxonomySharingForm'
import { Dropdown, DropdownItem, DropdownMenu } from 'element-ui'

export default {
    name: 'ManageTaxonomy',

    components: {
        ConfirmationModal,
        ManageTaxonomyTree,
        Panel,
        SectionHeader,
        SegmentDetails,
        SegmentForm,
        ScreenLockLoader,
        TaxonomyForm,
        TaxonomySharingForm,
        'el-dropdown': Dropdown,
        'el-dropdown-menu': DropdownMenu,
        'el-dropdown-item': DropdownItem,
    },

    data() {
        return {
            searchValue: '',
            searchResultsList: {},
            searchTargets: [
                { label: 'Label', value: 'label' },
                { label: 'Id', value: 'id' },
                { label: 'Category', value: 'category' }
            ],
            searchTarget: 'label',
            to: null,
            displayConfirmationModal: false,
            confirmationModalButtons: [
                { action: this.closeModal, label: 'Close' },
                { action: this.discardChanges, label: 'Discard and continue' },
                { action: this.saveChanges, label: 'Save and continue' }
            ],
            nextTaxoId: null,
            editTaxonomyPayload: {},
            isRedirectedFromAllocation: false,
            maximumTaxos: 5,
            customTaxonomiesIdsCloned: []
        }
    },

    computed: {
        ...mapState('account', {
            userRole: state => state.userRole,
            accountId: state => state.accountId,
        }),

        ...mapState('ui/manageTaxonomy', {
            hierarchies: state => state.hierarchies,
            selectedTaxoId: state => state.selectedTaxoId,
            isLoading: state => state.isLoading.taxonomy,
            isSearching: state => state.isSearching,
            displayModal: state => state.formSegment.displayModal,
            displayTaxonomyModal: state => state.formTaxonomy.displayModal,
            displaySharingTaxonomyModal: state => state.displaySharingTaxonomyModal,
            formAction: state => state.formSegment.type,
            selectedSegmentId: state => state.selectedSegmentId,
            counters: state => state.counters,
            formTaxonomyAction: state => state.formTaxonomy.type,
            isProcessing: state => state.isProcessing
        }),

        ...mapState('data/customTaxonomies', {
            customTaxonomies: state => state.customTaxonomies,
            dataHierarchies: state => state.hierarchies
        }),

        ...mapState('data/settings', {
            sharedTaxonomies: state => state.sharing.sharedTaxonomies
        }),

        ...mapGetters('ui/manageTaxonomy', ['getItemById', 'getTaxoSearchResults', 'getNodeAncestorsIds']),

        ...mapGetters('account', ['getAccessToManageTaxo']),

        ...mapGetters('ui/builder', ['criteriaListIsReady']),

        hasUserAccessToManageTaxo() {
            return this.getAccessToManageTaxo()
        },

        isDataLoading() {
            return !this.criteriaListIsReady
        },

        // TREE
        showHierarchy() {
            return !isEmpty(this.treeData)
        },

        treeData() {
            return get(this.hierarchies, `${this.selectedTaxoId}`, [])
        },

        emptyCustomTaxonomies() {
            return isEmpty(this.customTaxonomies)
        },

        customTaxonomiesIds() {
            return map(this.customTaxonomies, taxo => taxo.id)
        },

        // SEGMENT DETAILS
        segmentInfo() {
            return this.displayModal && this.formAction === 'create'
                ? {
                    children: [],
                    bootstrap_status: 'unavailable',
                    old_label: null,
                    key: null,
                    parent_id: null,
                    action: 'create',
                    id: null,
                    label: null,
                    smart_segments: []
                }
                : this.getItemById({
                    list: this.treeData,
                    id: this.selectedSegmentId
                })
        },

        // SEARCH
        showResultList() {
            return !isEmpty(this.searchResultsList)
        },

        searchResultsHeader() {
            if (this.showResultList) return head(Object.keys(this.searchResultsList))
            return null
        },

        searchResultsData() {
            if (this.showResultList) return head(Object.values(this.searchResultsList))
            return null
        },

        hasCounterActivated() {
            return this.counters.dragged > 0 || this.counters.deleted > 0 || this.counters.updated > 0 || this.counters.created > 0
        },

        modalTaxonomyClass() {
            return `${this.formTaxonomyAction}_taxonomy`
        },

        taxoCounters() {
            const stateCount = this.dataHierarchies[this.selectedTaxoId].length
            return stateCount + this.counters.created - this.counters.deleted
        },

        maximumSegment() {
            const type = this.customTaxonomies.find(item => item.id === this.selectedTaxoId).taxonomy_type
            return type === 'direct' || type === 'crm' ? 10000 : 5000
        },

        taxoCounterClassName() {
            const stateCount = this.dataHierarchies[this.selectedTaxoId].length

            if (this.taxoCounters > this.maximumSegment) return 'taxo-counter-danger'
            else if (this.taxoCounters > stateCount) return 'taxo-counter-increase'
            else if (this.taxoCounters < stateCount) return 'taxo-counter-decrease'
            else return ''
        }
    },

    watch: {
        customTaxonomiesIds: {
            handler: function(newValue, oldValue) {
                if (!isEmpty(newValue) && includes(this.$route.path, 'manage-taxonomy')) {
                    if (newValue.length !== oldValue.length) {
                        const taxoId = newValue[newValue.length - 1]
                        this.displayData(taxoId, null)
                    } else {
                        this.displayData(this.selectedTaxoId, null)
                    }
                }
            }
        },

        searchTarget: {
            handler: function(newValue, oldValue) {
                if (this.searchValue !== '' && newValue !== oldValue) {
                    this.launchSearch()
                }
            }
        },

        isDataLoading: {
            handler: function(newValue) {
                if (!newValue && !isNil(this.selectedTaxoId)) {
                    if (this.hasUserAccessToManageTaxo && isEmpty(this.treeData) && !this.isLoading) {
                        this.retrieveHierarchyOfSelectedTaxonomy({ taxoId: this.selectedTaxoId })
                    }
                }
            }
        },

        hasCounterActivated: {
            handler: function(newValue) {
                this.setHasCounterActivated({ value: newValue })
            }
        }
    },

    beforeRouteEnter(_to, from, next) {
        next(vm => {
            if (!isNil(vm.selectedSegmentId)) {
                vm.retrieveHierarchyOfSelectedTaxonomy({ taxoId: vm.selectedTaxoId }).then(() => {
                    vm.selectCustomSegment(vm.selectedSegmentId)
                    vm.setIsSearching({ isSearching: true })
                    vm.isRedirectedFromAllocation = from.name === 'allocation'
                })
            }
        })
    },

    beforeRouteLeave(to, from, next) {
        if (!this.hasCounterActivated) {
            next()
        } else {
            if (this.to) {
                next()
            } else {
                this.to = to
                this.displayConfirmationModal = true
            }
        }
    },

    mounted() {
        this.retrieveTaxonomySharingStatus()
    },

    created() {
        if (this.hasUserAccessToManageTaxo && isEmpty(this.treeData) && !this.isLoading) {
            this.retrieveHierarchyOfSelectedTaxonomy({ dataType: 'Direct' })
        }
    },

    methods: {
        ...mapActions('ui/manageTaxonomy', [
            'exportTaxonomy',
            'importTaxonomy',
            'retrieveItems',
            'saveTaxonomy',
            'retrieveHierarchyOfSelectedTaxonomy',
            'resetStoreOnRouteLeave',
            'testPromiseModal',
            'retrieveTaxonomySharingStatus'
        ]),

        ...mapMutations('ui/manageTaxonomy', [
            'setSelectedTaxoId',
            'setSelectedSegmentId',
            'setSegmentForm',
            'setIsSearching',
            'setDisplayingSearch',
            'setParents',
            'resetTaxoCountingData',
            'setDisplayConfirmationModal',
            'setRetrievedItems',
            'setIsLoading',
            'setTaxonomyForm',
            'setIsProcessing',
            'setDisplaySharingTaxonomyModal',
            'setSelectedSharingTaxonomy',
            'setHasCounterActivated'
        ]),

        ...mapActions('data/customTaxonomies', [
            'retrieveWamCustomTaxonomies'
        ]),

        // DATA ACTIONS
        displayData(taxoId, segmentId) {
            if (this.selectedTaxoId !== taxoId) {
                this.resetTaxoCountingData()
            }

            if (!this.isSearching && (isEmpty(this.treeData) || this.selectedTaxoId !== taxoId)) {
                this.retrieveHierarchyOfSelectedTaxonomy({ taxoId })
            }

            this.setSelectedTaxoId({ id: taxoId })
            this.setSelectedSegmentId({ id: segmentId })
        },

        selectTaxonomy(id) {
            if (this.hasCounterActivated) {
                this.nextTaxoId = id
                this.displayConfirmationModal = true
            } else {
                this.displayData(id, null)
            }
        },

        editTaxonomy(taxonomy) {
            this.editTaxonomyPayload = taxonomy
            this.setTaxonomyForm({ displayModal: true, type: 'edit' })
        },

        createCustomSegment() {
            this.setSegmentForm({
                displayModal: true,
                type: 'create',
                activeTab: 'information'
            })
        },

        scrollHorizontalyInHierarchy(level) {
            const el = this.$refs.manageTaxonomyColumnsContainer
            el.scrollTo({
                left: level * 224,
                behavior: 'smooth'
            })
        },

        // HIERARCHIES ACTIONS
        _exportTaxonomy() {
            this.exportTaxonomy({ taxoId: this.selectedTaxoId })
        },

        displayWarning() {
            if (this.hasCounterActivated) {
                this.$store.commit(
                    'notifications/setAddedNotification',
                    {
                        type: 'warning',
                        message: 'Your changes changes will be discarded'
                    },
                    { root: true }
                )
            }
        },

        _importTaxonomy(event) {
            const file = head(event.target.files)
            if (file.name.match(/\.csv$/)) {
                if (!isNil(file) || !isEmpty(file)) {
                    this.setIsProcessing({ value: true })
                    this.importTaxonomy({ file }).then(() => {
                        this.setIsProcessing({ value: false })
                    })
                }
                // chrome hack to be able to upload a file after it was removed
                document.getElementById('uploadTaxo').value = ''
            } else {
                this.$store.commit(
                    'notifications/setAddedNotification',
                    {
                        type: 'error',
                        message: 'Your file have to be a CSV file'
                    },
                    { root: true }
                )
            }
        },

        // FORM - MODAL
        closeForm() {
            this.setTaxonomyForm({ displayModal: false, type: 'create' })
            if (this.displayModal) {
                this.setSegmentForm({
                    displayModal: false,
                    type: 'create',
                    activeTab: 'information'
                })
            } else if (this.displaySharingTaxonomyModal) {
                this.setDisplaySharingTaxonomyModal({ display: false })
                this.setSelectedSharingTaxonomy({ taxo: null })
                this.closeModal()
            }
            if (this.displayConfirmationModal) {
                this.closeModal()
            }
        },

        // CONFIRMATION MODAL
        closeModal() {
            this.displayConfirmationModal = false
            this.to = null
            this.nextTaxoId = null
        },

        closeModalAndLeave() {
            this.displayConfirmationModal = false
            this.resetStoreOnRouteLeave()
            this.$router.push(this.to)
            this.to = null
        },

        closeModalAndDisplayData() {
            this.displayConfirmationModal = false
            this.displayData(this.nextTaxoId, null)
            this.nextTaxoId = null
        },

        discardChanges() {
            this.resetStoreOnRouteLeave()
            if (this.to) {
                //route leave
                this.closeModalAndLeave()
            } else {
                //taxo type change
                this.setRetrievedItems({ id: this.selectedTaxoId, items: [] })
                this.closeModalAndDisplayData()
            }
        },

        cancelChanges() {
            this.resetTaxoCountingData()
            this.retrieveHierarchyOfSelectedTaxonomy({ taxoId: this.selectedTaxoId })
        },

        saveChanges() {
            this.setIsLoading({ item: 'taxonomy', isLoading: true })
            this.displayConfirmationModal = false
            this.saveTaxonomy({ displaySavedTaxo: true })
                .then(response => {
                    if (response.isSaved) {
                        if (this.to) {
                            //route leave
                            this.closeModalAndLeave()
                        } else {
                            //taxo type change
                            this.setIsLoading({ item: 'taxonomy', isLoading: false })
                            this.closeModalAndDisplayData()
                        }
                    } else {
                        this.setIsLoading({ item: 'taxonomy', isLoading: false })
                        this.closeModal()
                    }
                })
                .catch(() => {
                    this.setIsLoading({ item: 'taxonomy', isLoading: false })
                    this.closeModal()
                })
        },

        // SEARCH
        launchSearch() {
            this.isRedirectedFromAllocation = false
            if (this.searchValue.trim()) {
                this.setIsSearching({ isSearching: true })
                this.searchResultsList = this.getTaxoSearchResults({
                    searchPattern: this.searchValue,
                    type: this.searchTarget
                })
            }
        },

        resetSearch(shouldResetIsSearching) {
            this.searchResultsList = {}
            this.searchValue = ''

            // reset isSearching on cancelSearch click, otherwise,
            // reset isSearching is done in ManageTaxonomyTree
            if (shouldResetIsSearching) {
                this.setIsSearching({ isSearching: false })
            }
        },

        checkInput(event) {
            // check user erasing searchValue: if value back to '', cancel search

            // !! watcher on searchValue is not working because we need isSearching bool to keep
            // !! its value when iser clicks on a search result
            if (event.inputType === 'deleteContentBackward' && event.target.value === '') {
                this.setIsSearching({ isSearching: false })
            }
        },

        selectCustomSegment(segmentId) {
            this.setSelectedSegmentId({ id: null })

            this.$nextTick(() => {
                const _cs = this.getItemById({ list: this.treeData, id: segmentId })

                // first level segment
                if (isNil(_cs.parent_id)) {
                    this.displayData(this.selectedTaxoId, _cs.id)
                }
                // 2+ level segment
                else {
                    this.setDisplayingSearch({ isDisplaying: true })
                    const parents = cloneDeep(
                        this.getNodeAncestorsIds({
                            ancestors: [_cs.id],
                            node: _cs
                        })
                    )
                    this.displayData(this.selectedTaxoId, segmentId)
                    this.setParents({ parents })
                    this.$nextTick(() => {
                        this.scrollHorizontalyInHierarchy(parents.length)
                    })
                }
                this.resetSearch(false)
            })
        },

        setEditSharing(taxo) {
            this.setDisplaySharingTaxonomyModal({ display: true })
            this.setSelectedSharingTaxonomy({ taxo: taxo })
        },

        saveHierarchy() {
            this.setSelectedSegmentId({ id: null })
            this.saveTaxonomy({ displaySavedTaxo: true }).then(() => {
                this.retrieveWamCustomTaxonomies({
                    accountId: this.accountId
                })
            })
        },

        getSharingCounter(taxo) {
            return helpers.formatSharedTaxonomies(this.sharedTaxonomies[taxo.id]).length
        },

        handleCommand(command) {
            if (command === 'download') {
                this._exportTaxonomy(this.selectedTaxoId)
                return
            }

            if (command === 'import') {
                this.$refs['nav-uploadTaxo'].click()
                return
            }

            if (command === 'new') {
                this.setTaxonomyForm({ displayModal: true, type: 'create' })
                return
            }

            if (command === 'share') {
                this.setDisplaySharingTaxonomyModal({ display: true })
                return
            }
        },
    }
}
</script>
